import { DatePipe } from "@angular/common";
import { Component, Input, OnInit } from "@angular/core";
import { FormControl, FormGroup } from "@angular/forms";
import { MatDialog } from "@angular/material/dialog";
import { Event, NavigationEnd, Router } from "@angular/router";
import { TokenStorageService } from "src/app/core/auth/token-storage.service";
import { ApiCallService } from "src/app/core/services/api-call-service";
import { getdateformatService } from "src/app/core/services/get-date-format.service";
import { SnackbarCollection } from "src/app/core/services/snackbar.service";
import { SendTestEmailDialogComponent } from "src/app/shared/components/dialog-box";

@Component({
  selector: 'app-subscription-report',
  templateUrl: './subscription-report.component.html',
  styleUrls: ['./subscription-report.component.css']
})
export class SubscriptionReportComponent implements OnInit {

  constructor(
    private tokenStorage: TokenStorageService,
    private snackBar: SnackbarCollection,
    private apiCall: ApiCallService,
    private date_format: getdateformatService,
    public datepipe: DatePipe,
    private dialog: MatDialog,
    private router: Router
  ) {
    this.router.events.subscribe((event: Event) => {
      if (event instanceof NavigationEnd) {
        this.currentUrl = event.url.split(";")[0];
      }
    });
  }

  selectedStatus = [];
  selectedMemberships =[];
  loading = false;
  reportType = "";
  typeOfStatus = [
    {
      type: "ACTIVE",
      name: "Active",
    },
    {
      type: "CANCELLED",
      name: "Cancelled",
    },
    {
      type: "INACTIVE",
      name: "Inactive",
    }
  ];
  filter = {
    label: "",
  };
  membershipTiers: any[] = [];
  currentUrl = "";

  @Input() selectedTab: string = "";

  ngOnInit(): void {
      if(this.currentUrl.includes("subscriptionlist/checkin-report")){
        this.reportType = "MEMBERSHIP_CHECKIN_REPORT";
      } else{
        this.reportType = "MEMBERSHIP_REPORT";
        this.getMembershipTiers()
      }
  }


  getMembershipTiers() {
    this.apiCall.getAllMembershipPlans()
      .subscribe((response: any) => {
        if (response.message === "success") {
          this.membershipTiers = response.body;
        }
      }, (error) => {
        console.error("Failed to fetch membership details", error);
      });
  }

  sendReportViaEmail() {
    const dialogRef = this.dialog.open(SendTestEmailDialogComponent, {
      panelClass: "no-padding-dialog-popup",
      height: "auto",
      data: {
        subject: "Send report via email",
        message: "Please enter the email address to which the report should be sent.",
        reportEmail: true,
        downloadOption: ["Excel"],
        buttonNmae: "Send",
      },
      disableClose: true,
      width: "50%",
    });

    dialogRef.afterClosed().subscribe((response) => {
      if (response != false) {
        let prefix = ".csv";
        let filePath = "/tmp/" + this.tokenStorage.getMerchantId() +"_"+this.reportType + prefix;
        if(this.reportType === 'MEMBERSHIP_REPORT')
          this.sendMembershipReport(filePath, response.email, response["type"]);
        else
          this.sendCheckInReport(filePath, response.email, response["type"])
      }
    });
  }

  sendMembershipReport(filePath, email, fileType) {
    this.snackBar.openSnackBar(
      "Report download will start in a few minutes.",
      2000
    );
    let data = {
      featureName: "MEMBERSHIP_REPORT",
      type: fileType.toUpperCase(),
      filePath: filePath,
      sendToEmailId: email,
      reportType: "MEMBERSHIP_REPORT"
    };
    if (this.selectedStatus.length > 0) {
      data["subscriptionStatus"] = this.selectedStatus;
    }
    if (this.selectedMemberships.length > 0) {
      data["subscriptionId"] = this.selectedMemberships; 
    }
    this.getReportsApi(data).then(
      (result) => {
        this.snackBar.openSnackBar(result["body"], 2000);
      },
      (err) => {
        this.loading = false;
        this.snackBar.openSnackBar(err.body, 2000);
      }
    );
  }

  sendCheckInReport(filePath, email, fileType) {
    this.snackBar.openSnackBar(
      "Report download will start in a few minutes.",
      2000
    );
    let data = {
      featureName: "MEMBERSHIP_CHECKIN_REPORT",
      type: fileType.toUpperCase(),
      filePath: filePath,
      sendToEmailId: email,
      reportType: "MEMBERSHIP_CHECKIN_REPORT"
    };
    this.getReportsApi(data).then(
      (result) => {
        this.snackBar.openSnackBar(result["body"], 2000);
      },
      (err) => {
        this.loading = false;
        this.snackBar.openSnackBar(err.body, 2000);
      }
    );
  }

  getReportsApi(data) {
    return new Promise((resolve, reject) => {
      this.apiCall.getReportSampleData(data).subscribe(
        (res) => {
          console.log(res);
          resolve(res);
        },
        (err) => {
          console.log(err.error);
          reject(err.error);
        }
      );
    });
  }


}
